// Analysis containers
window.$ = require("jquery")

import "../vendor/js/leaflet-src"
import "../vendor/js/Leaflet.VectorGrid.bundled"
import "../vendor/js/easy-button"
import "../vendor/js/leaflet.ajax.min"
import "../vendor/js/iconv-lite.bundle.js"
import "../vendor/css/easy-button.css"
import "../vendor/css/leaflet.css"
import "../vendor/css/style.css"
import vgrid from './vgrid'

import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import VueRouter from 'vue-router';
import axios from 'axios'
import VueAxios from 'vue-axios'
import AnalysisApp from '../components/analysis/analysis-app.vue'

Vue.use(VueAxios, axios)
$("#analysis_nav_link").addClass("active font-weight-bold")

Vue.use(VueRouter);
const routerA = new VueRouter({ routes: [ /* ... */ ], mode: 'history' });


new Vue({
  el: document.getElementById("analysis-app"),
  data() {
    return {
      vgrid: vgrid,
    }
  },
  router: routerA,
  render: (h) => h(AnalysisApp)
}).$mount()
